import React from "react";
import { View, StyleSheet } from "react-native";
import NtCaseStudySectionContainer from "./NtCaseStudySectionContainer";
import NtCaseStudyText from "./NtCaseStudyText";
import NtCaseStudyTextBold from "./NtCaseStudyTextBold";
import NtCaseStudyTextBullet from "./NtCaseStudyTextBullet";

function NtCaseStudyNaviCommunication(props) {
  return (
    <NtCaseStudySectionContainer
      style={styles.container}
      title={"Modernizing U.S. Navy Communications at NAS Key West"}
      subtitle={"Transition from TDM to VoIP/IP Central Office Services"}
    >
      <NtCaseStudyText>
        <NtCaseStudyTextBold>Overview</NtCaseStudyTextBold>
        {"\n\n"}In late 2024 and early 2025, NT Connect Holdings, Inc. was
        contracted by NCTAMS LANT to conduct a comprehensive site survey and
        deliver a forward-looking communications solution for Naval Air Station
        Key West and its annexes. This initiative targeted the transformation of
        aging Time Division Multiplexing (TDM)-based telephony infrastructure
        into a modern, scalable, and efficient Voice over Internet Protocol
        (VoIP) system.{"\n\n"}{" "}
        <NtCaseStudyTextBold>Client Background</NtCaseStudyTextBold>
        {"\n\n"}NAS Key West is a strategically significant site supporting the
        operational and readiness needs of the U.S. Navy, Department of Defense
        (DoD), Department of Homeland Security (DHS), and allied forces. The
        Navy sought a phased, low-disruption migration from this outdated
        infrastructure to a VoIP environment, without access to Government
        Furnished Outside Plant (OSP) infrastructure, and with limited as-is
        documentation or mapping.{"\n\n"}{" "}
        <NtCaseStudyTextBold>Solution</NtCaseStudyTextBold>
        {"\n\n"}NT Connect developed a solution to transition the Navy’s
        telephony system from legacy TDM to VoIP using modern IP technologies
        while minimizing cost, disruption, and new infrastructure demands.{" "}
        {"\n\n"}Key aspects of the solution included:
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>
          Utilization of Existing CAT 3 Cabling
        </NtCaseStudyTextBold>{" "}
        Leveraged existing Inside Plant wiring to avoid extensive rewiring.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Bypass of Legacy OSP Systems:</NtCaseStudyTextBold>{" "}
        Designed an IP-centric network approach that circumvents dependency on
        degraded or inaccessible infrastructure.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>
          Vendor-Provided VoIP/IP Central Office Services:
        </NtCaseStudyTextBold>{" "}
        Shifted the telephony core to a commercial VoIP model to reduce
        lifecycle costs and increase reliability.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Scalable Architecture:</NtCaseStudyTextBold>{" "}
        Enabled future expansion and integration with evolving DoD
        communications standards.
      </NtCaseStudyTextBullet>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Why NT Connect</NtCaseStudyTextBold>
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Mission-Critical Experience:</NtCaseStudyTextBold>{" "}
        Proven track record delivering resilient IT and communications solutions
        to federal defense customers.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Agile Engineering: </NtCaseStudyTextBold> Rapid
        response, flexible design, and hands-on field assessments led to
        actionable solutions in less than 60 days.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Cost-Efficient Execution: </NtCaseStudyTextBold>{" "}
        Balanced cutting-edge VoIP technologies with real-world constraints to
        reduce total ownership costs.
      </NtCaseStudyTextBullet>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Outcome & Next Steps</NtCaseStudyTextBold>
        {"\n\n"}NT Connect’s deliverables included:
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        A fully scoped transition plan
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Cost breakdown for one-time and recurring services
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Use-case-ready infrastructure diagrams
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        Notional timeline for phased implementation
      </NtCaseStudyTextBullet>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        The project provided a roadmap for a fast, efficient VoIP upgrade and a
        template for replication across other Navy facilities.{"\n\n"}
        <NtCaseStudyTextBold>Looking Ahead</NtCaseStudyTextBold>
        {"\n\n"}NT Connect continues to support U.S. Navy modernization
        initiatives with secure, scalable, and mission-ready communications
        infrastructure. Our commitment to innovation and execution ensures that
        military installations like NAS Key West are prepared for the demands of
        next-generation operations.
      </NtCaseStudyText>
    </NtCaseStudySectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {},
});

export default NtCaseStudyNaviCommunication;
